import React, { useContext, useEffect } from 'react'
import { onAuthStateChanged, signInWithCustomToken, signOut, User } from 'firebase/auth'
import { createContext, useState } from 'react'
import { firebaseAuth } from 'src/utils/firebase'
import { getCookieByName } from 'src/utils/cookies/getCookieByName'
import { getCurrentUser, logout } from 'src/actions/user.actions'
import { useDispatch } from 'react-redux'

interface FirebaseSession {
  user: User | null | boolean
  isSignedIn: boolean
  isSessionLoading?: boolean
}

export const FirebaseContext = createContext<FirebaseSession | undefined>(undefined)

export const useFirebaseSession = () => useContext(FirebaseContext)

function FirebaseProvider({ children }: { children: React.ReactElement }) {
  const [user, setUser] = useState<User | null | false>(false)
  const [isSessionLoading, setIsSessionLoading] = useState(false)

  const isSignedIn = Boolean(user)

  const dispatch = useDispatch()
  const loginUser = async (customToken: string) => {
    setIsSessionLoading(true)
    try {
      return await signInWithCustomToken(firebaseAuth, customToken)
    } catch (error) {
      dispatch(logout())
    } finally {
      setIsSessionLoading(false)
    }
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(firebaseAuth, user => {
      if (user) {
        setUser(user)
        dispatch(getCurrentUser())
        // loggedIn
      } else {
        setUser(null)
        // no valid
      }
    })

    return () => unsubscribe()
  }, [dispatch, getCurrentUser])

  useEffect(() => {
    const customToken = getCookieByName('firebase.customToken')

    if (!user) {
      if (customToken) {
        loginUser(customToken)
      }
    }

    if (user) {
      if (!customToken) {
        dispatch(logout())
      }
    }
  }, [user])

  return (
    <FirebaseContext.Provider value={{ user, isSignedIn, isSessionLoading }}>
      {children}
    </FirebaseContext.Provider>
  )
}

export default FirebaseProvider
